<section class="page-section">
  <app-shared-ticket-page *ngIf="ticketUid && service" [serviceUid]="service.uid" [ticketUid]="ticketUid"></app-shared-ticket-page>
</section>
